import { Ban } from 'lucide-react';
import React from 'react';
import { useAutomationEditorContext } from '../AutomationEditorContext';
import styles from '../EditAutomationTemplate.module.css';
import { useSegmentDefinitions } from '../useSegmentDefinitions';
import {
  getExclusionNames,
  MULTIPLE_EXCLUSIONS_CARD_PREFIX,
  NO_EXCLUSION_CARD_LABEL,
  SINGLE_EXCLUSION_CARD_PREFIX,
} from './trigger-exclusions';

export const TriggerExclusionSummary: React.FC = () => {
  const { editor } = useAutomationEditorContext();
  const { data: segmentDefinitions } = useSegmentDefinitions();
  const exclusionNames = getExclusionNames(
    editor.state.localContents.excludeSegmentDefaults,
    segmentDefinitions,
  );
  const hasExclusions = exclusionNames.length > 0;
  const hasMultipleExclusions = exclusionNames.length > 1;
  const prefix = hasMultipleExclusions ? MULTIPLE_EXCLUSIONS_CARD_PREFIX : SINGLE_EXCLUSION_CARD_PREFIX;
  const summary = hasExclusions ? `${prefix} ${exclusionNames.join(', ')}` : NO_EXCLUSION_CARD_LABEL;

  return (
    <p className={styles.exclusionSummary} data-active={hasExclusions || undefined}>
      <Ban aria-hidden="true" />
      {summary}
    </p>
  );
};
